// extracted by mini-css-extract-plugin
export default {"Tab":"L2OLQbSa4_","TabActive":"wnbqa_eRvr"};